import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { RoutesConst } from '../shared/route-const';

@Component({
  selector: 'app-my-profile',
  imports: [MatButtonModule, RouterLink],
  templateUrl: './my-profile.component.html',
  styleUrl: './my-profile.component.scss',
})
export class MyProfileComponent {
  authSvc = inject(AuthService);
  routesConst = RoutesConst;
  showMainRoute = signal(true);
}
